import React from 'react';
import styled from '@emotion/styled';
import { useDynamicUrlPath } from 'client/hooks/useDynamicUrlPath';
import { Button } from 'client/shared/Button/NewButton';
import { useT } from 'client/i18n/hooks/useT';
import { SCREEN_BREAKPOINTS } from '../../../constants';
import { AdsByAnchorIcon } from '../../Icons';

const HeaderContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 575px;
  margin: auto;
  padding: 100px 0 0;

  .ads-by-anchor-icon {
    width: 100%;
    max-width: 500px;
    margin: auto;
    padding-bottom: 25px;
  }

  .ads-by-anchor-signup-button {
    width: 100%;
    max-width: 136px;
    margin: 0 auto;
  }

  @media (max-width: ${SCREEN_BREAKPOINTS.SMALL_DESKTOP}px) {
    width: 90%;
    padding: 0;
  }
`;
const HiddenHeaderTitle = styled.h1`
  height: 0;
  overflow: hidden;
`;

const HeaderSubtitle = styled.p`
  margin: 0 0 30px;
  color: #ffffff;
  font-size: 2.5rem;
  line-height: 3.5rem;
  letter-spacing: -0.01em;
  text-align: center;

  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    margin: 0 0 25px;
    font-size: 2.2rem;
    line-height: 2.8rem;
  }
`;

export const HeaderContent = () => {
  const { path } = useDynamicUrlPath({ destinationPath: '/dashboard/money' });
  const t = useT();
  return (
    <HeaderContentContainer>
      <HiddenHeaderTitle>
        {t('AdsByAnchorScreen.Header.HeaderContent.Title', 'Ads by Anchor', '')}
      </HiddenHeaderTitle>
      <AdsByAnchorIcon aria-hidden={true} id="ads-by-anchor-icon-header" />
      <HeaderSubtitle>
        {t(
          'AdsByAnchorScreen.Header.HeaderContent.Subtitle',
          'The all-in-one, flexible podcast monetization platform made for everyone, powered by Spotify.',
          ''
        )}
      </HeaderSubtitle>
      <Button
        className="ads-by-anchor-signup-button"
        color="yellow"
        kind="link"
        href={path}
      >
        {t(
          'AdsByAnchorScreen.Header.HeaderContent.SignupButtonLabel',
          'Sign up',
          'Sign up button text'
        )}
      </Button>
    </HeaderContentContainer>
  );
};
